import { Project } from "interfaces";

import FilterSummary from "ui-components/Data-Filters/Filter-Summary";

import { projectIsImpactAnalysisContinous } from "flows/impact-analysis-continous/interfaces";

import {
  getYVariable,
  getTreatmentConditions,
  getTreatmentControlTags,
} from "flows/impact-analysis-continous/utils";

const ContextSummary = ({ project }: { project: Project }) => {
  if (!projectIsImpactAnalysisContinous(project)) return null;

  const yVariable = getYVariable(project);
  const conditions = getTreatmentConditions(project);
  const [treatmentTag, controlTag] = getTreatmentControlTags(project);

  return (
    <div className="m-1">
      <p className="mb-2">
        1. Target Variable: <span className="underline">{yVariable}</span>
      </p>
      <p>
        2. <span className="underline">{treatmentTag}</span>: Rows which meet
        ALL the below conditions:
      </p>
      <ul className="list list-inside list-decimal pl-2 ml-2 mb-2">
        {conditions.map((f, i) => (
          <li key={i} className="list-item">
            <FilterSummary filter={f} />
          </li>
        ))}
      </ul>
      <p>
        3. All other rows are <span className="underline">{controlTag}</span>.
      </p>
    </div>
  );
};

export default ContextSummary;
